import React from "react";
import { CheckCircle2, XCircle } from "lucide-react";
import { SectionHeader } from "./_shared";

export default function NotJustDealFlow() {
  const rows = [
    ["Founder-filled profiles", "Company intelligence-backed profiles"],
    ["Pitch deck-led discovery", "Trust Score and diligence-led discovery"],
    ["Open interest forms", "Controlled query workflow"],
    ["Static startup listings", "Dynamic Startup Passport"],
    ["Basic filters", "Investor Mandate Fit"],
    ["Generic data rooms", "Secure deal rooms with diligence reports"],
    ["No structured feedback", "Readiness recommendations and rejection intelligence"],
    ["Limited verification", "Admin-approved visibility and confidence labels"],
  ];
  return (
    <section className="py-16 lg:py-20 bg-cream" data-testid="not-just-deal-flow-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader
          eyebrow="THE DIFFERENCE"
          title="Not just deal flow. Verified deal intelligence."
          align="center"
        />
        <div className="overflow-hidden rounded-lg border border-navy/10 bg-white shadow-sm">
          <div className="grid grid-cols-2">
            <div className="p-4 bg-navy/[0.03] text-[11px] font-mono uppercase tracking-[0.2em] text-ink-muted border-b border-navy/10">Ordinary Startup Platform</div>
            <div className="p-4 bg-gold/10 text-[11px] font-mono uppercase tracking-[0.2em] text-[#8A6600] border-b border-navy/10 border-l border-navy/10">VENTURAZ</div>
            {rows.map(([a, b], i) => (
              <React.Fragment key={i}>
                <div className={`p-4 flex items-center gap-2 text-sm text-ink-soft ${i < rows.length - 1 ? "border-b border-navy/5" : ""}`} data-testid={`diff-row-a-${i}`}>
                  <XCircle size={14} className="text-rose-400 flex-shrink-0" /> {a}
                </div>
                <div className={`p-4 flex items-center gap-2 text-sm text-ink bg-gold/[0.04] border-l border-navy/10 ${i < rows.length - 1 ? "border-b border-navy/5" : ""}`} data-testid={`diff-row-b-${i}`}>
                  <CheckCircle2 size={14} className="text-emerald-500 flex-shrink-0" /> <span className="font-heading">{b}</span>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
